"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Plans = function Plans(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.36 15.196H4.64c-1.103 0-2.003-.9-2.003-2.004V6.808c0-1.104.9-2.004 2.004-2.004h10.72c1.104 0 2.004.9 2.004 2.004v6.38c0 1.108-.9 2.008-2.004 2.008zM4.64 6.036a.777.777 0 00-.775.776v6.38c0 .428.348.776.776.776h10.72a.773.773 0 00.772-.776V6.808a.776.776 0 00-.772-.776H4.64v.004z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.172 13.06a.613.613 0 01-.604-.716l.296-1.716-1.248-1.216a.617.617 0 01.34-1.052l1.72-.252.768-1.56c.208-.42.896-.42 1.104 0l.772 1.56 1.72.252a.617.617 0 01.34 1.052l-1.248 1.216.296 1.716a.612.612 0 01-.244.6.612.612 0 01-.648.048L10 12.18l-1.54.808a.56.56 0 01-.288.072zM10 10.872c.1 0 .196.024.288.072l.724.38-.14-.804a.61.61 0 01.176-.544l.584-.572-.808-.116a.622.622 0 01-.464-.336L10 8.216l-.36.732a.615.615 0 01-.464.336l-.808.116.584.572a.61.61 0 01.176.544l-.14.804.724-.38a.662.662 0 01.288-.068z",
    fill: secondaryColor
  }));
};
var _default = exports["default"] = Plans;